<template>
  <div class="swiper-img">
    <swiper class="shorex-banner" :options="swiperOptions" ref="bannerSwiper" @slideChange="onSlideChange()">
      <swiper-slide v-for="(item, j) in bannerList" :key="j">
        <img v-if="item.bannerType===0" :src="item.bannerImageUrl" alt="">
        <DestinationVideo v-else
                          :videoUrl="item.bannerImageUrl"
                          :coverUrl="item.pcVideoImage"
                          @onChangeVideo="onChangeVideoPlay"
        />
      </swiper-slide>
    </swiper>
    <a v-if="bannerList.length > 1 && swiperIndex!==0" class="swiper-btn-left"
       @click="goPrev()">
      <span class="" aria-hidden="true">
          <img
              src="https://resource.rcclchina.com.cn/paySuccess/left-btn.png"
              alt="">
      </span>
    </a>
    <a v-if="bannerList.length > 1 &&swiperIndex!==bannerList.length-1"
       @click="goNext()" class="swiper-btn-right">
       <span class="" aria-hidden="true">
           <img
               src="https://resource.rcclchina.com.cn/paySuccess/right-btn.png"
               alt="">
       </span>
    </a>
  </div>
</template>
<script>
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";
import DestinationVideo from "@/components/Alert/DestinationVideo.vue";
import 'swiper/css/swiper.css'
export default {
  name: "shoreSightseeSwiper",
  components: {
    DestinationVideo,
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive
  },
  props: {
    bannerList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      swiperOptions: {
        loop: false,
        speed: 500,
        autoplay: true,
      },
      swiperIndex: 0,
      videoUrl: '',
      isAutoplay:true
    }
  },
  methods: {
    goPrev() {
      let swiper = this.$refs.bannerSwiper.$swiper
      this.swiperIndex = swiper.realIndex - 1
      swiper.slidePrev()
    },
    goNext() {
      let swiper = this.$refs.bannerSwiper.$swiper
      this.swiperIndex = swiper.realIndex + 1
      swiper.slideNext()
    },
    onSlideChange() {
      //   获取当前滑动下标
      let swiper = this.$refs.bannerSwiper.$swiper
      this.swiperIndex = swiper.realIndex
    },
    onChangeVideoPlay(){
      let swiper = this.$refs.bannerSwiper.$swiper
      swiper.autoplay.stop()
    }
  },
}
</script>
<style scoped lang="less">
.swiper-img {
  position: relative;
  width: 100%;
  height: 100%;
  & .shorex-banner{
    width: 100%;
    height: 100%;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }

  }
  & .swiper-btn-right {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
    z-index: 9;
    width: 15px;
    height: 25px;
  }

  & .swiper-btn-left {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
    z-index: 9;
    width: 15px;
    height: 25px;
  }

  img {
    width: 100%;
    height: 100%;
  }
}
</style>